import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.vpn.addUser;

const { actions, reducer, sagas, additionalSagas, selectors } = createAPIModule(
	{
		getStateSlice,
		actionType: 'VPN_ADDUSER',
		method: 'POST',
		url: '/vpn/addUser.json',
	},
);

export { actions, reducer, sagas, additionalSagas, selectors };
